/* ==========================================================================
   ORW Hero - Tab switching with horizontal watch carousel
   Gradient: set directly on right panel background via JS
   Watch: scale+slide carousel (right->center->left)
   ========================================================================== */

(function() {
  'use strict';

  var section, rightPanel, tabs, slides, badge, subtext, headingTrack, headings, cta;
  var gradientData = [];
  var currentIndex = 0;
  var totalSlides = 0;
  var rotationSpeed = 5;
  var autoTimer = null;
  var isAnimating = false;

  function init() {
    section = document.querySelector('[data-orw-hero]');
    if (!section) return;

    rightPanel = section.querySelector('[data-orw-hero-right]');
    tabs = section.querySelectorAll('[data-orw-hero-tab]');
    slides = section.querySelectorAll('[data-orw-hero-slide]');
    badge = section.querySelector('[data-orw-hero-badge]');
    cta = section.querySelector('[data-orw-hero-cta]');
    subtext = section.querySelector('[data-orw-hero-subtext]');
    headingTrack = section.querySelector('[data-orw-hero-heading-track]');
    headings = headingTrack ? headingTrack.querySelectorAll('.orw-hero__heading') : [];
    rotationSpeed = parseInt(section.getAttribute('data-rotation-speed'), 10) || 5;
    totalSlides = tabs.length;

    /* Parse gradient data from embedded JSON */
    var jsonEl = section.querySelector('[data-orw-hero-gradients]');
    if (jsonEl) {
      try {
        gradientData = JSON.parse(jsonEl.textContent);
      } catch(e) {
        gradientData = [];
      }
    }

    if (totalSlides <= 1) return;

    preloadBackgrounds();

    /* Set initial state */
    if (slides[0]) slides[0].classList.add('is-active');
    if (tabs[0]) tabs[0].classList.add('is-active');

    /* Bind tab clicks */
    for (var i = 0; i < tabs.length; i++) {
      (function(idx) {
        tabs[idx].addEventListener('click', function() {
          if (isAnimating || idx === currentIndex) return;
          goToSlide(idx);
          stopAuto();
          startAuto();
        });
      })(i);
    }

    startAuto();
  }

  /* Background images are only referenced from JS, so the browser would
     fetch each one on its first tab switch (blank panel for 1-2s).
     Warm the cache once the page has finished loading instead. */
  function preloadBackgrounds() {
    var run = function() {
      for (var i = 1; i < gradientData.length; i++) {
        if (gradientData[i] && gradientData[i].i) {
          var img = new Image();
          img.decoding = 'async';
          img.src = gradientData[i].i;
        }
      }
    };
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  function goToSlide(newIndex) {
    if (newIndex === currentIndex || isAnimating) return;
    isAnimating = true;

    var oldIndex = currentIndex;

    /* 1. Switch tabs */
    for (var i = 0; i < tabs.length; i++) {
      if (i === newIndex) {
        tabs[i].classList.add('is-active');
        tabs[i].setAttribute('aria-selected', 'true');
      } else {
        tabs[i].classList.remove('is-active');
        tabs[i].setAttribute('aria-selected', 'false');
      }
    }

    /* 2. Change background directly on right panel -- image wins if present */
    if (rightPanel && gradientData[newIndex]) {
      var g = gradientData[newIndex];
      if (g.i) {
        /* Gradient underneath so the panel is never blank while the image loads */
        rightPanel.style.background = 'url(' + g.i + ') center/cover no-repeat, linear-gradient(360deg, ' + g.s + ' 0%, ' + g.e + ' 100%)';
      } else {
        rightPanel.style.background = 'linear-gradient(360deg, ' + g.s + ' 0%, ' + g.e + ' 100%)';
      }
    }

    /* 3. Watch carousel: old exits left, new enters from right */
    if (slides[oldIndex]) {
      slides[oldIndex].classList.remove('is-active');
      slides[oldIndex].classList.add('is-exiting');
    }
    if (slides[newIndex]) {
      slides[newIndex].classList.add('is-active');
    }

    /* Clean up exit class after animation */
    setTimeout(function() {
      if (slides[oldIndex]) {
        slides[oldIndex].classList.remove('is-exiting');
      }
      isAnimating = false;
    }, 550);

    /* 4. Update badge */
    if (badge && tabs[newIndex]) {
      badge.textContent = tabs[newIndex].textContent.trim();
    }

    /* 4b. "Discover Now" text and link follow the active slide */
    if (cta && gradientData[newIndex]) {
      var slideData = gradientData[newIndex];
      if (slideData.l) cta.setAttribute('href', slideData.l);
      if (slideData.t) {
        var ctaLabels = cta.querySelectorAll('span');
        for (var c = 0; c < ctaLabels.length; c++) ctaLabels[c].textContent = slideData.t;
      }
    }

    /* 5. Slide heading track */
    if (headingTrack && headings.length > 0) {
      var h = headings[0].offsetHeight;
      var gap = 40;
      try { gap = parseInt(window.getComputedStyle(headingTrack).gap, 10) || 40; } catch(e) {}
      headingTrack.style.transform = 'translateY(-' + (newIndex * (h + gap)) + 'px)';
    }

    /* 6. Fade subtext */
    if (subtext && headings[newIndex]) {
      var newText = headings[newIndex].getAttribute('data-orw-hero-subtext-value');
      if (newText) {
        subtext.style.opacity = '0';
        setTimeout(function() {
          subtext.textContent = newText;
          subtext.style.opacity = '1';
        }, 250);
      }
    }

    currentIndex = newIndex;
  }

  function startAuto() {
    stopAuto();
    autoTimer = setInterval(function() {
      var next = (currentIndex + 1) % totalSlides;
      goToSlide(next);
    }, rotationSpeed * 1000);
  }

  function stopAuto() {
    if (autoTimer) {
      clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
